export const FREQUENCIA = Object.freeze({
  DIARIO: "DIARIO",
  SEMANAL: "SEMANAL",
});

export const TIPO_EXCEL = Object.freeze({
  ABA_UNICA: "ABA_UNICA",
  ABAS_SEPARADAS: "ABAS_SEPARADAS",
});

export const REPORT_TYPE = Object.freeze({
  KMZ: "KMZ",
  PDF: "PDF",
  EXCEL: "EXCEL",
});
